import { useEffect, useLayoutEffect, useState } from 'react';
import { makeStyles, Snackbar, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Draggable from "react-draggable";
import UtilService from "../../../../../../../helper/service";
import clsx from "clsx";
import { removeMarker, updateMarker, addOverviewToAnalysisKeyMoment } from "../../../../../../../store/actions/creator/analysis";
import EditNoteItem from "./editNoteItem";
import DoneIcon from "@material-ui/icons/Done";
import { Alert } from "@material-ui/lab";
import constants from '../../../../../../../config/constants';
import _ from 'underscore';
import { apiClient } from '../../../../../../../config/apiClient';
import AnalyzeKeyMomentPopOut from '../../../../../../atoms/creator/analyzeKeyMomentPopout';

const useStyles = makeStyles(() => ({
  agendaRoot: {
    display: 'flex',
    width: '100%',
    minHeight: 80,
    position: 'relative',
  },
  title: {
    minWidth: constants.ANALYZE.AGENDA_MIN_WIDTH,
    background: '#fff',
    padding: '8px 7px',
    borderRadius: 12,
    borderTopLeftRadius: 0,
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    color: '#0179EE',
    fontFamily: 'roboto-regular',
    fontSize: 12,
    cursor: 'context-menu',
  },
  pdfTitle: {
    minWidth: constants.ANALYZE.AGENDA_MIN_WIDTH,
    background: '#fff',
    padding: '8px 7px',
    borderRadius: 12,
    borderTopLeftRadius: 0,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    color: '#0179EE',
    fontFamily: 'roboto-regular',
    fontSize: 12,
    cursor: 'context-menu',
  },
  clock: {
    width: 12,
    height: 12,
    marginRight: 3
  },
  timeLabel: {
    fontFamily: 'Spartan-extrabold',
    fontSize: 10,
    marginRight: 3
  },
  segmentWord: {
    fontFamily: 'Spartan-bold',
    fontSize: 8,
    textTransform: 'uppercase',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  textBlack: {
    color: '#323232',
  },
  textEllipsis: {
    maxWidth: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word'
  },
  drag_title: {
    minWidth: constants.ANALYZE.AGENDA_MIN_WIDTH,
    padding: '4px 10px',
    borderRadius: 12,
    borderTopLeftRadius: 0,
    color: '#0179EE',
    fontFamily: 'roboto-regular',
    fontSize: 12,
    marginLeft: -4,
  },
  box: {
    width: 30,
    height: 20,
    zIndex: 0,
    background: '#fff',
    padding: 4,
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
  },
  pdfBox: {
    width: 30,
    height: 20,
    zIndex: 0,
    background: '#fff',
    padding: 4,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
  },
  hidden: {
    width: 30,
    height: 5,
    background: '#fff',
    position: 'absolute',
    left: 0,
    marginTop: -3
  },
  resizable: {
    width: 16,
    position: 'relative',
    top: 0,
  },
  bar: {
    width: '100%',
    height: 24,
    zIndex: -1,
    position: 'absolute',
    background: '#e5f1fe',
  },
  times: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    color: '#333333',
    fontSize: 12,
    fontFamily: 'roboto-bold',
    marginBottom: -15
  },
  iconRBox: {
    padding: 5,
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: -25
  },
  iconLBox: {
    padding: 5,
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: -18,
    cursor: 'pointer'
  },
  description: {
    padding: '6px 0',
    background: '#fff',
    paddingBottom: 18,
    boxShadow: "0 3px 4px rgba(0, 0, 0, 0.1)",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4
  },
  textField: {
    "& .MuiInputBase-root": {
      color: '#0179EE',
      fontFamily: 'roboto-regular',
      fontSize: 12,
      marginTop: -4,
      background: '#e5f1fe',
      padding: '5px'
    }
  },
  pencil: {
    position: 'absolute',
    zIndex: 100,
    cursor: 'pointer'
  },
  iconDone: {
    position: 'absolute',
    zIndex: 100,
    cursor: 'pointer',
    color: '#1db859',
    margin: '-2px 0 0 1px'
  },
  popover: {
    background: '#fff',
    width: 226,
    boxShadow: '0px 0px 10px #00000033',
    borderRadius: 10,
    marginTop: 6,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0 0 -2px 12px'
  },
  popperTitle: {
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 14
  },
  name_index: {
    margin: '0 7px',
    fontSize: 18
  },
  label_index: {
    fontFamily: 'Spartan-bold',
    letterSpacing: 1.2,
    paddingTop: 4,
    textTransform: 'uppercase'
  },
  popperBadgeIcon: {
    width: 20,
    height: 20
  },
  mb20: {
    marginBottom: '20px !important'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#1DB859',
    fontSize: 12,
    margin: 0,
    '& p:first-of-type': {
      margin: '0 7px',
      fontSize: 18,
    },
    '& p:nth-of-type(2)': {
      fontFamily: 'Spartan-bold',
      letterSpacing: 1.2,
      paddingTop: 4,
      textTransform: 'uppercase',
    }
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  btn: {
    marginTop: 18,
    marginLeft: 5,
    padding: '3px 4px 3px 4px',
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 10,
    background: '#F0F0F0',
    borderRadius: 6,
    textTransform: 'none',
    '&:hover': {
      background: '#e7e5e5',
    },
    '& img': {
      marginRight: 3
    }
  },
  label: {
    fontSize: 12,
    fontFamily: 'roboto-bold',
    color: '#697683',
    textAlign: 'left',
  },
  smallRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#8191A1',
    '& img': {
      width: 12,
      height: 12,
      marginRight: 3
    }
  },
  pane: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'Spartan-bold',
    fontSize: 8,
    color: '#8191A1',
    marginTop: 6
  },
}));

function AgendaSection(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { markers, currentSession, analyseStart, analyseEnd, cliped, identifiers, settings, overviewToKeymoment, excludedParticipants } = useSelector((state: any) => state.analysis);
  const { session_code, session_trim_from, session_trim_to, started_at, ended_at, scheduled_end_at } = currentSession;

  const { lineStep, onZoom } = props;
  const { graphZoom, pdfLoading } = settings;

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const apolloClient = useSelector((state: any) => state.apolloClient)
  const start_at = Math.floor(analyseStart ? analyseStart : (currentSession ? currentSession.started_at : 0));
  // const end_at = Math.floor(analyseEnd ? analyseEnd : (currentSession ? currentSession.ended_at : 0));

  let notes = markers.filter((item: any) => item.marker_type === 1 && item.start_marker_at !== '0')

  const [editIndex, setEditIndex] = useState(-1);
  const [agendas, setAgendas] = useState(notes);
  const [agendasPosition, setAgendasPosition] = useState<any>([]);
  const [startPoint, setStartPoint] = useState(0);
  const [endPoint, setEndPoint] = useState(0);
  const [curDrag, setCurDrag] = useState(0);
  const [curDraggingId, setCurDraggingId] = useState(-1);
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [agendaPopup, setAgendaPopup] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const [clipName, setClipName] = useState<string>('Clip ');
  const [immersion, setImmersion] = useState<any>(null);
  const [safety, setSafety] = useState<any>(null);
  const [curAgenda, setCurAgenda] = useState<any>(null);
  const [editNoteWidth, setEditNoteWidth] = useState(0);

  const start = cliped ? cliped.start_clip - Number(analyseStart) : 0;
  const end = cliped ? cliped.end_clip - Number(analyseStart) : Number(analyseEnd);
  const sessionDuration = Number(analyseEnd) - Number(analyseStart);
  const AGENDA_MIN_LINE_WIDTH = Math.floor(constants.ANALYZE.AGENDA_MIN_WIDTH * Math.pow(graphZoom, 2) / lineStep) + 2;
  const NOTE_MIN_WIDTH = 10;
  const analysed_end = Math.floor(ended_at ? ended_at : scheduled_end_at);

  useLayoutEffect(() => {
    window.addEventListener('resize', updateEditNoteWidth);
    // return () => {
    //     window.removeEventListener('resize', updateEditNoteWidth);
    // };
  })

  useEffect(() => {
    if (overviewToKeymoment) {
      const hasKey = document.getElementById("agenda_" + overviewToKeymoment?.marker_id)
      if (hasKey) {
        hasKey.click();
        dispatch(addOverviewToAnalysisKeyMoment(null))
      }
    }
  }, [overviewToKeymoment])

  useEffect(() => {
    updateEditNoteWidth();
  }, [graphZoom]);

  useEffect(() => {

    if (!markers || !analyseStart || !analyseEnd) return;

    notes = markers.filter((item: any) => item.marker_type === 1 && item.start_marker_at !== '0');
    setAgendas(notes);
  }, [markers, analyseStart, analyseEnd]);

  const onKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onEditDone();
    }
  }

  const updateEditNoteWidth = () => {

    const timer1 = setTimeout(() => {
      const commentContainer = document.getElementById("agenda_container");
      if (!commentContainer) return;

      setEditNoteWidth(commentContainer.offsetWidth);
    }, 100)
    return () => {
      clearTimeout(timer1)
    }
  }

  const getNoteWidth = (item: any) => {
    let noteWidth = (item.end_marker_at - item.start_marker_at) * lineStep / Math.pow(graphZoom, 2);

    if (cliped) {
      const noteStartPosition = getEditStartXPosition(item);
      const clipLength = cliped.end_clip - cliped.start_clip;
      const offset = (noteStartPosition + noteWidth) - clipLength * lineStep / Math.pow(graphZoom, 2);
      if (offset > 0) noteWidth -= offset;
    }

    return noteWidth;
  }

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  const getEpochTime = (epoch_time: number) => {
    if (currentSession['session_status'] === 'COMPLETED' && identifiers.length > 0) {
      return UtilService.secondsToHms(Number(epoch_time) - analyseStart);
    } else {
      return UtilService.secondsToHms(Number(epoch_time) - analyseStart);
    }
  };

  const getRuntime = (epoch_start: number, epoch_end: number) => {
    return UtilService.overviewHighlightsTimeFormat(epoch_end - epoch_start);
  };

  const showAgendaPopup = async (event: any, data: any) => {

    const requestMod = {
      identifiers: _.difference(identifiers, excludedParticipants),
      from_epoch: Number(data.start_marker_at),
      to_epoch: Number(data.end_marker_at),
      session_started_at: session_trim_from ? Number(started_at) : analyseStart,
      session_completed_at: session_trim_to ? analysed_end : analyseEnd,
      tenant_id: Number(loginUserData.customer_id),
      session_code,
    };

    setAnchorEl(event.currentTarget);

    Promise.all([
      getImmersion(requestMod, data),
      getSafety(requestMod, data)
    ])

    setAgendaPopup(true);

  }

  const getImmersion = async (request: any, data: any) => {

    const newImmersion = {
      color_indicator: "gray",
      context_indicator: "No Data",
      end: Number(data.end_marker_at),
      overall_index: '--',
      start: Number(data.start_marker_at),
      tier_indicator: "Blank"
    }

    try {
      const res = await apiClient(true).post(`/analysis/v2/sync/index/immersion/${loginUserData.customer_id}/${session_code}`, { ...request });
      if (res.data) {
        newImmersion['color_indicator'] = res.data.color_indicator ? res.data.color_indicator : 'gray';
        newImmersion['overall_index'] = res.data.immersion_index;
        newImmersion['context_indicator'] = res.data.context_indicator;
        setImmersion(newImmersion);
      }
    } catch {
    }

    setImmersion(newImmersion);

  }

  const getSafety = async (request: any, data: any) => {
    const newSafety = {
      color_indicator: "gray",
      context_indicator: "",
      end: Number(data.end_marker_at),
      overall_index: '--',
      start: Number(data.start_marker_at),
      tier_indicator: ""
    }

    try {
      const res = await apiClient(true).post(`/analysis/v2/sync/index/safety/${loginUserData.customer_id}/${session_code}`, { ...request });
      if (res.data) {
        newSafety['color_indicator'] = res.data.color_indicator;
        newSafety['overall_index'] = res.data.safety_index > 1 ? res.data.safety_index : '--';
        newSafety['context_indicator'] = res.data.context_indicator;
        setSafety(newSafety);
      }
    } catch {

    }
    setSafety(newSafety);

  }

  const onItemBodyClick = (event: any, item: any) => {
    setAnchorEl(null);
    setImmersion(null);
    setSafety(null);

    if ((currentSession['session_status'] === 'COMPLETED' || (currentSession['session_type'] === 'ASYNC')))
      showAgendaPopup(event, item);

    setCurAgenda(item);
    setClipName(item.marker_title);
  };

  const editNote = (item: any) => {
    setEditIndex(item.marker_id);
    setStartPoint(Number(item.start_marker_at) - start_at);
    setEndPoint(Number(item.end_marker_at) - start_at);
  }

  const onEditDone = async () => {
    setAgendaPopup(false);
    setCurAgenda(null)
    const comment = agendas.find((item: any) => item.marker_id === editIndex);
    onSaveAgenda(comment);
    setEditIndex(-1);
  }

  const onRemoveMarker = (id: string) => {
    setAgendas(agendas.filter((item: any) => item.marker_id !== id));

    const newAgendas = agendas.filter((item: any) => item.marker_id !== id);
    adjustAgendas(newAgendas);
    setAgendasPosition(agendasPosition.filter((item: any) => item.id !== id));

    dispatch(removeMarker(apolloClient.client, {
      marker_id: parseInt(id)
    }))

  };

  const onEditNote = (text: string, id: any) => {
    setAgendas(agendas.map(
      (comment: any) => comment.marker_id === id ? { ...comment, marker_title: text } : comment
    ))
  }

  const onHandleDrag = (e: any, id: number) => {

    const ids = agendasPosition.map((item: any) => item.id);
    const defaultPosition = agendasPosition.map(
      (position: any) => {
        if (position.id === id) {
          const drag = position.drag + e.movementX / lineStep / Math.pow(/*graphZoom*/ 1, 2);
          setCurDrag(drag);
        }
        return position.id === id ? {
          ...position,
          drag: position.drag + e.movementX / lineStep / Math.pow(/*graphZoom*/ 1, 2)
        } : position
      }
    );
    if (!ids.includes(id)) {
      defaultPosition.push({
        id,
        drag: e.movementX / lineStep / Math.pow(graphZoom, 2),
        resizeLeft: 0,
        resizeRight: 0,
        marker_title: ''
      });
    }
    setAgendasPosition(defaultPosition);
    setCurDraggingId(id);
  }

  const onDragStop = ({ }, id: number) => {

    setCurDrag(0);
    setCurDraggingId(-1);

    const currentCommentPosition = agendasPosition.find((item: any) => item.id === id);
    if (Boolean(currentCommentPosition)) {
      const currentComment = agendas.find((item: any) => item.marker_id === id);
      if (Boolean(currentComment)) {
        currentComment.start_marker_at = Number(currentComment.start_marker_at) + Math.floor(currentCommentPosition.drag * Math.pow(graphZoom, 2));
        currentComment.end_marker_at = Number(currentComment.end_marker_at) + Math.floor(currentCommentPosition.drag * Math.pow(graphZoom, 2));

        let offsetX = Number(currentComment.start_marker_at) - start_at - start;
        if (offsetX < 0) {
          currentComment.start_marker_at = Number(currentComment.start_marker_at) - offsetX;
          currentComment.end_marker_at = Number(currentComment.end_marker_at) - offsetX;
        }

        offsetX = Number(currentComment.end_marker_at) - (cliped ? cliped.end_clip : analyseEnd);
        if (offsetX > 0) {
          currentComment.start_marker_at = Number(currentComment.start_marker_at) - offsetX - 2;
          currentComment.end_marker_at = Number(currentComment.end_marker_at) - offsetX - 2;
        }

        onSaveAgenda(currentComment);
      }
      setAgendasPosition(agendasPosition.map(
        (item: any) => item.id === id ? { ...item, drag: 0 } : item
      ))
    }
  }

  // resizing left side of agenda item - start_marker_at
  const onResizeLeftStop = ({ }, id: string) => {
    const currentCommentPosition = agendasPosition.find((item: any) => String(item.id) === id);
    if (Boolean(currentCommentPosition)) {
      const currentIndex = agendas.findIndex((item: any) => String(item.marker_id) === id);
      const prevComment = currentIndex > 0 ? agendas[currentIndex - 1] : null;
      const nextComment = currentIndex < agendas.length ? agendas[currentIndex + 1] : null;
      const currentComment = agendas[currentIndex];

      if (Boolean(currentComment)) {

        const oldComment = { ...currentComment };
        const resizeLeft = Math.floor(currentCommentPosition.resizeLeft * Math.pow(graphZoom, 2));
        const minimumLeftWidth = prevComment ? Number(currentComment.start_marker_at) - Number(prevComment.start_marker_at) + resizeLeft : AGENDA_MIN_LINE_WIDTH;
        const minimumRightWidth = nextComment
          ? Number(nextComment.start_marker_at) - Number(currentComment.start_marker_at) - resizeLeft
          : Number(currentComment.end_marker_at) - Number(currentComment.start_marker_at) - resizeLeft

        if (resizeLeft >= 0) { // right direction resize
          if (minimumRightWidth >= AGENDA_MIN_LINE_WIDTH) {
            currentComment.start_marker_at = Number(currentComment.start_marker_at) + resizeLeft;
          } else {
            if (nextComment) {
              currentComment.start_marker_at = Number(nextComment.start_marker_at) - AGENDA_MIN_LINE_WIDTH;
            } else {
              currentComment.start_marker_at = Number(currentComment.end_marker_at) - AGENDA_MIN_LINE_WIDTH;
            }
          }
        } else { // left direction resize
          if (minimumLeftWidth >= AGENDA_MIN_LINE_WIDTH) {
            currentComment.start_marker_at = Number(currentComment.start_marker_at) + resizeLeft;
          } else {
            if (prevComment) currentComment.start_marker_at = Number(prevComment.start_marker_at) + AGENDA_MIN_LINE_WIDTH;
          }
        }

        // if (currentComment.start_marker_at <= start_at + start)
        //   currentComment.start_marker_at = start_at + start

        // if (currentComment.end_marker_at >= (start_at + sessionDuration))
        //   currentComment.end_marker_at = start_at + sessionDuration

        setAgendas(agendas.map(
          (comment: any) => String(comment.marker_id) === id ? currentComment : comment
        ))

        adjustLeftAgendas(oldComment, currentComment);
      }
      setAgendasPosition(agendasPosition.map(
        (item: any) => String(item.id) === id ? { ...item, resizeLeft: 0, resizeRight: 0 } : item
      ))
    }
  }

  const onResizeLeft = (e: any, id: string) => {

    let startPosition = startPoint + e.movementX / lineStep * Math.pow(graphZoom, 2);

    startPosition = Math.max(startPosition, start);
    const moveX = (startPosition - startPoint) / Math.pow(graphZoom, 2) * lineStep;
    setStartPoint(startPosition);

    const ids = agendasPosition.map((item: any) => String(item.id))
    const defaultPosition = agendasPosition.map(
      (position: any) => String(position.id) === id ? {
        ...position,
        resizeLeft: position.resizeLeft + moveX / lineStep / Math.pow(/*graphZoom*/ 1, 2)
      } : position
    );
    if (!ids.includes(id)) {
      defaultPosition.push({
        id,
        resizeLeft: moveX / lineStep / Math.pow(/*graphZoom*/ 1, 2),
        drag: 0,
        marker_title: ''
      })
    }

    setAgendasPosition(defaultPosition)

  };

  // resizing right side of agenda item - end_marker_at
  const onResizeRightStop = ({ }, id: string) => {
    const currentCommentPosition = agendasPosition.find((item: any) => String(item.id) === id);
    if (Boolean(currentCommentPosition)) {

      const currentIndex = agendas.findIndex((item: any) => String(item.marker_id) === id);
      const nextComment = currentIndex < agendas.length ? agendas[currentIndex + 1] : null;
      const prevComment = currentIndex > 0 ? agendas[currentIndex - 1] : null;
      const currentComment = agendas[currentIndex];

      if (Boolean(currentComment)) {

        const oldComment = { ...currentComment };
        const resizeRight = Math.floor(currentCommentPosition.resizeRight * Math.pow(graphZoom, 2));
        const minimumRightWidth = nextComment ? Number(nextComment.end_marker_at) - Number(currentComment.end_marker_at) - resizeRight : AGENDA_MIN_LINE_WIDTH;
        const minimumLeftWidth
          = prevComment
            ? -Number(prevComment.end_marker_at) + Number(currentComment.end_marker_at) + resizeRight
            : -Number(currentComment.start_marker_at) + Number(currentComment.end_marker_at) + resizeRight;

        if (resizeRight >= 0) { // right direction resize
          if (minimumRightWidth >= AGENDA_MIN_LINE_WIDTH) {
            currentComment.end_marker_at = Number(currentComment.end_marker_at) + resizeRight;
          } else {
            if (nextComment) currentComment.end_marker_at = Number(nextComment.end_marker_at) - AGENDA_MIN_LINE_WIDTH;
          }
        } else { // left direction resize

          if (minimumLeftWidth >= AGENDA_MIN_LINE_WIDTH) {
            currentComment.end_marker_at = Number(currentComment.end_marker_at) + resizeRight;
          } else {
            if (prevComment) {
              currentComment.end_marker_at = Number(prevComment.end_marker_at) + AGENDA_MIN_LINE_WIDTH
            } else {
              currentComment.end_marker_at = start_at + start + AGENDA_MIN_LINE_WIDTH
            }
          }
        }

        // if (currentComment.start_marker_at <= (start_at + start)){
        //   currentComment.start_marker_at = start_at + start
        // }

        if (currentComment.end_marker_at >= (start_at + sessionDuration)) {
          currentComment.end_marker_at = start_at + sessionDuration
        }

        setAgendas(agendas.map(
          (comment: any) => String(comment.marker_id) === id ? currentComment : comment
        ))

        adjustRightAgendas(oldComment, currentComment);
      }
      setAgendasPosition(agendasPosition.map(
        (item: any) => String(item.id) === id ? { ...item, resizeLeft: 0, resizeRight: 0 } : item
      ))
    }
  }

  const onResizeRight = (e: any, id: string) => {

    let endPosition = endPoint + e.movementX / lineStep * Math.pow(graphZoom, 2);

    endPosition = Math.min(endPosition, sessionDuration);
    const moveX = (endPosition - endPoint) / Math.pow(graphZoom, 2) * lineStep;
    setEndPoint(endPosition);

    const ids = agendasPosition.map((item: any) => String(item.id))
    const defaultPosition = agendasPosition.map(
      (position: any) => String(position.id) === id ? {
        ...position,
        resizeRight: position.resizeRight + moveX / lineStep / Math.pow(/*graphZoom*/ 1, 2)
      } : position
    );
    if (!ids.includes(id)) {
      defaultPosition.push({
        id,
        resizeRight: moveX / lineStep / Math.pow(/*graphZoom*/ 1, 2),
        drag: 0,
        marker_title: ''
      })
    }
    setAgendasPosition(defaultPosition);
  };

  const isLeft = (agenda1: any, agenda2: any) => {
    return Number(agenda1.end_marker_at) === Number(agenda2.start_marker_at)
  }

  const isRight = (agenda1: any, agenda2: any) => {
    return Number(agenda1.start_marker_at) === Number(agenda2.end_marker_at);
  }

  const adjustLeftAgendas = (oldAgenda: any, newAgenda: any) => {
    const duration = Number(newAgenda.start_marker_at) - (start_at);

    setAgendas(agendas.map((item: any) => {
      if (isLeft(item, oldAgenda)) {
        const agenda = {
          ...item,
          end_marker_at: start_at + duration
        };
        updateAgenda(agenda);
        return agenda;
      }
      return item;
    }))
  }

  const adjustRightAgendas = (oldAgenda: any, newAgenda: any) => {
    setAgendas(agendas.map((item: any) => {
      if (isRight(item, oldAgenda)) {
        const agenda = {
          ...item,
          start_marker_at: Number(newAgenda.end_marker_at),
        };
        updateAgenda(agenda);
        return agenda;
      }
      return item;
    }))
  }

  const adjustAgendas = (newAgendas: any) => {
    const adjustLength = newAgendas.length;
    const duration = Number(analyseEnd) - Number(analyseStart);

    setAgendas(newAgendas.map((item: any, index: number) => {
      const agenda = {
        ...item,
        start_marker_at: start_at + (duration / adjustLength) * index,
        end_marker_at: start_at + (duration / adjustLength) * (index + 1)
      };
      updateAgenda(agenda);
      return agenda;
    }));
  }

  const onSaveAgenda = async (agenda: any) => {

    if (!agenda) return;

    if (agenda.can_save === false) {
      return;
    }

    if (agenda.can_save === true) {
      agenda.can_save = false;
    }

    setAgendas(agendas.map(
      (item: any) => item.marker_id === agenda.marker_id ? agenda : item
    ))

    const request: any = {
      session_code,
      marker_title: agenda.marker_title,
      marker_start_at: Math.floor(Number(agenda.start_marker_at)).toString(),
      marker_end_at: Math.floor(Number(agenda.end_marker_at)).toString(),
      marker_type: agenda.marker_type,
      user_id: parseInt(loginUserData.user_id),
      marker_id: parseInt(agenda.marker_id)
    }

    if (parseInt(agenda.marker_id) > 1000000) {
      delete request.marker_id;
    }

    dispatch(updateMarker(apolloClient.client, request, (res: any) => {

      if (agenda.can_save === false) {

        const old_marker_id = agenda.marker_id;
        if (res.updateMarker.data) {
          agenda.marker_id = res.updateMarker.data.marker_id;
        }

        delete agenda.can_save;

        setAgendas(agendas.map(
          (item: any) => item.marker_id === old_marker_id ? agenda : item
        ))
      }
    }));
  }

  const updateAgenda = (agenda: any) => {

    if (!agenda) return;

    const request: any = {
      session_code,
      marker_title: agenda.marker_title,
      marker_start_at: Math.floor(Number(agenda.start_marker_at)).toString(),
      marker_end_at: Math.floor(Number(agenda.end_marker_at)).toString(),
      marker_type: agenda.marker_type,
      user_id: parseInt(loginUserData.user_id),
      marker_id: parseInt(agenda.marker_id)
    }

    if (parseInt(agenda.marker_id) > 1000000) {
      delete request.marker_id;
    }

    dispatch(updateMarker(apolloClient.client, request, () => {
    }));
  }

  const getStartXPosition = (item: any) => {
    const xPosition = getEditStartXPosition(item);
    return xPosition;
  }

  const getEditStartXPosition = (item: any) => {
    const xPosition = ((parseInt(item.start_marker_at) - start_at - start) / Math.pow(graphZoom, 2)) * lineStep;
    return xPosition;
  }

  const getEndXPosition = (item: any) => {
    const xPosition = ((parseInt(item.end_marker_at) - start_at - start) / Math.pow(graphZoom, 2)) * lineStep;
    return xPosition;
  }

  const getEditEndXPosition = (item: any) => {
    const xStartPosition = getEditStartXPosition(item);
    let xEndPosition = getEndXPosition(item);
    const width = xEndPosition - xStartPosition;
    if (width < NOTE_MIN_WIDTH) {
      xEndPosition += (NOTE_MIN_WIDTH - width);
    }

    return xEndPosition;
  }

  const dragElement = (item: any) => <div style={{ position: 'relative', zIndex: (editIndex === item.marker_id) ? 4 : 0 }}>
    <div style={{ position: 'absolute', paddingBottom: 12 }}>

      <div
        className={pdfLoading ? classes.pdfBox : classes.box}
        style={{ visibility: (editIndex !== item.marker_id) ? 'visible' : 'hidden' }}
      >
        <img
          src={'/assets/icons/liveanalysis/agenda-icon.svg'}
          style={{ marginTop: 2, marginLeft: 3 }}
          alt={'img'}
          onClick={() => {
            setAnchorEl(null);
            if (item.can_save === false) {
              setShownSnackAlert(true);
            } else {
              editNote(item);
            }
          }}
          className={classes.pencil}
        />
      </div>

      {(editIndex !== item.marker_id) &&
        <>
          <div className={classes.hidden}></div>
        </>
      }

      <div>

        <div className='handle'>

          <div>
            {editIndex === item.marker_id &&
              <>
                <EditNoteItem
                  // width={((item.end_marker_at - item.start_marker_at) / Math.pow(graphZoom, 2) + UtilService.getResizeEndPoint(commentsPosition, item)) * lineStep}
                  onResizeLeft={(e: any) => onResizeLeft(e, String(item.marker_id))}
                  onResizeLeftStop={(e: any) => onResizeLeftStop(e, String(item.marker_id))}
                  onResizeRight={(e: any) => onResizeRight(e, String(item.marker_id))}
                  onResizeRightStop={(e: any) => onResizeRightStop(e, String(item.marker_id))}
                  wrapperClass1={clsx(classes.resizable)}
                  wrapperClass2={clsx(classes.resizable)}
                  editNoteWidth={editNoteWidth}
                  noteMinWidth={NOTE_MIN_WIDTH}
                  startXPosition={getEditStartXPosition(item)}
                  endXPosition={editNoteWidth - (getEditEndXPosition(item)) - 0} // Final agenda right width
                  style={{
                    // border: '1px solid red',
                    position: 'absolute',
                    left: `${-getEditStartXPosition(item)}px`,
                    top: `${-20}px`,
                    width: `${(editNoteWidth - 2 - 4)}px`, // Final agenda right width
                    height: '300px',
                    paddingTop: `${-20}px`,
                    // paddingLeft: `${getEditXPosition(item)}px`,
                    marginTop: 16,
                    marginLeft: 3,
                    display: 'flex'
                  }}
                >
                  {/*<div className={classes.bar}/>*/}

                  {(editIndex === item.marker_id) &&
                    <>
                      <div className={pdfLoading ? classes.pdfBox : classes.box}>
                        <DoneIcon
                          onClick={() => {
                            onEditDone();
                          }
                          }
                          fontSize={'small'}
                          className={classes.iconDone}
                        />
                      </div>
                    </>
                  }

                  <div className={classes.description}>
                    <TextField
                      inputRef={(input) => {
                        input && input.focus();
                      }}
                      onFocus={(e) => e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
                      defaultValue={item.marker_title}
                      value={item.marker_title}
                      onChange={(e) => onEditNote(e.target.value, item.marker_id)}
                      onKeyPress={(e) => onKeyPress(e)}
                      fullWidth
                      multiline
                      InputProps={{
                        disableUnderline: true
                      }}
                      className={classes.textField}
                      placeholder={'Type something…'}
                    />
                  </div>

                  <div className={classes.iconLBox}>
                    <img
                      src={'/assets/icons/liveanalysis/trash-icon.svg'}
                      alt={'trash'}
                      onClick={() => onRemoveMarker(item.marker_id)}
                    />
                  </div>

                  <div className={classes.times}>
                    <span>{UtilService.getTimeLabel(startPoint, 1, 0)}</span>
                    <span>{UtilService.getTimeLabel(endPoint, 1, 0)}</span>
                  </div>
                </EditNoteItem>
              </>
            }

            {editIndex !== item.marker_id &&
              <div
                className={clsx(pdfLoading ? classes.pdfTitle : classes.title, classes.textBlack)}
                style={{
                  width: getNoteWidth(item),
                  cursor: 'pointer'
                }}
                id={'agenda_' + item.marker_id}
                onClick={(event: any) => onItemBodyClick(event, item)}
              >
                <div className={classes.textEllipsis}>
                  <span>{item.marker_title}</span>
                </div>
              </div>}

          </div>

          {curDraggingId === Number(item.marker_id) &&
            <div className={clsx(classes.times, classes.drag_title)}
              style={{
                width: ((item.end_marker_at - item.start_marker_at) / Math.pow(graphZoom, 2)) * lineStep,
              }}
            >
              <span className={classes.textBlack}>
                {UtilService.getStartTimeLabel((item.start_marker_at - start_at + curDrag * Math.pow(graphZoom, 2)), 1, 0)}
              </span>
              <span className={classes.textBlack}>
                {UtilService.getEndTimeLabel((item.start_marker_at - start_at + curDrag * Math.pow(graphZoom, 2)), (item.end_marker_at - start_at + curDrag * Math.pow(graphZoom, 2)), 1, 0)}
              </span>
            </div>
          }

        </div>
      </div>
    </div>
  </div>

  return (
    <div style={{ position: 'relative', paddingTop: 8 }}>
      <div
        className={classes.agendaRoot}
        id={'agenda_container'}>
        {
          agendas
            .filter((item: any) => (item.end_marker_at >= start_at + start + 1) && (item.start_marker_at <= start_at + end - 1))
            .map((item: any, index: number) => ((cliped && index === 0) ? {
              ...item, start_marker_at: start_at + start
            } : item))
            .map((item: any) =>
              <Draggable
                key={item.marker_id}
                bounds="parent"
                axis="x"
                position={{ x: getStartXPosition(item), y: 4 }}
                disabled={true}
                onDrag={(e) => onHandleDrag(e, Number(item.marker_id))}
                onStop={(e) => onDragStop(e, Number(item.marker_id))}
                {...{children: dragElement(item)}}
              />
            )
        }

        <Snackbar open={isShownSnackAlert} autoHideDuration={1400} onClose={hideSnackAlert}>
          <Alert onClose={hideSnackAlert} severity="error">Please wait until save the marker...</Alert>
        </Snackbar>
      </div>


      {agendaPopup && curAgenda && (immersion && safety) &&
        <AnalyzeKeyMomentPopOut
          anchorEl={anchorEl}
          onZoom={() => {
            setAnchorEl(null);
            if (onZoom && curAgenda)
              onZoom((Number(curAgenda?.end_marker_at) - Number(curAgenda?.start_marker_at)), curAgenda?.start_marker_at);
          }}
          setAnchorEl={setAnchorEl}
          clipName={clipName}
          overlay={{
            segment_length: getRuntime(curAgenda['start_marker_at'], curAgenda['end_marker_at']),
            segment_end: getEpochTime(curAgenda['end_marker_at']),
            segment_start: getEpochTime(curAgenda['start_marker_at']),
            safety_color: safety?.color_indicator,
            safety_index: safety?.overall_index,
            safety_indicator: safety?.context_indicator,
            overall_index: immersion?.overall_index,
            color_indicator: immersion?.color_indicator,
            color: immersion?.color_indicator,
            context_indicator: immersion?.context_indicator,
            type: 'Agenda',
            start: String(curAgenda['start_marker_at']),
            end: String(curAgenda['end_marker_at']),
            title: curAgenda.marker_title,
            epoch_start: curAgenda['start_marker_at'],
          }}
        />
      }

    </div>
  );
}

export default AgendaSection;